import { render, staticRenderFns } from "./backgroundSet.vue?vue&type=template&id=c3452c9e&scoped=true"
import script from "./backgroundSet.vue?vue&type=script&lang=js"
export * from "./backgroundSet.vue?vue&type=script&lang=js"
import style0 from "./backgroundSet.vue?vue&type=style&index=0&id=c3452c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3452c9e",
  null
  
)

export default component.exports